import { useMutation, useQueryClient } from '@tanstack/react-query'
import { APP } from 'Constants/App'
import { normalizeKoreanSchoolYearlyStatistics } from 'Entities/koreanSchoolYearlyStatistics'
import { useApiQuery } from 'Hooks/App/useApiQuery'
import { toast } from 'react-toastify'
import httpClient from 'Service'

export type KoreanSchoolYearlyPayload = {
  year: number
  schoolCount: number
  universityCount: number
}

const LIST_KEY = 'koreanSchoolYearlyStatistics'

export const useKoreanSchoolYearlyStatistics = () => {
  const queryClient = useQueryClient()

  const listQuery = useApiQuery<unknown>({
    key: LIST_KEY,
    url: '/api/org/korean-school-statistics/yearly',
  })

  const createMutation = useMutation({
    mutationFn: (payload: KoreanSchoolYearlyPayload) => httpClient.post('/api/account/korean-school-statistics/yearly', payload),
    onSuccess: () => {
      toast.success(APP.DATA_SUCCESS_SAVED)
      queryClient.invalidateQueries({ queryKey: [LIST_KEY] })
    },
    onError: () => {
      toast.error('Не удалось сохранить данные.')
    },
  })

  const updateMutation = useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: KoreanSchoolYearlyPayload }) =>
      httpClient.patch(`/api/account/korean-school-statistics/yearly/${id}`, payload),
    onSuccess: () => {
      toast.success(APP.DATA_SUCCESS_CHANGED)
      queryClient.invalidateQueries({ queryKey: [LIST_KEY] })
    },
    onError: () => {
      toast.error('Не удалось изменить данные.')
    },
  })

  const deleteMutation = useMutation({
    mutationFn: (id: number) => httpClient.delete(`/api/account/korean-school-statistics/yearly/${id}`),
    onSuccess: () => {
      toast.success(APP.DATA_SUCCESS_REMOVED)
      queryClient.invalidateQueries({ queryKey: [LIST_KEY] })
    },
    onError: () => {
      console.log('error')
      toast.error('Не удалось удалить запись.')
    },
  })

  return {
    items: normalizeKoreanSchoolYearlyStatistics(listQuery.data),
    isLoading: listQuery.isLoading,
    isFetching: listQuery.isFetching,
    createMutation,
    updateMutation,
    deleteMutation,
  }
}
